import React from 'react';
import { SEO } from '../components/SEO';

const sections = [
  { id: 'umumi', title: 'Ümumi müddəalar' },
  { id: 'qebul', title: 'Şərtlərin qəbulu' },
  { id: 'istifade', title: 'Saytın istifadəsi' },
  { id: 'muraciet', title: 'Müraciət formaları' },
  { id: 'muelliflik', title: 'Müəlliflik hüquqları' },
  { id: 'qadagan', title: 'Qadağan olunan fəaliyyətlər' },
  { id: 'mesuliyyet', title: 'Məsuliyyət məhdudiyyətləri' },
  { id: 'ucuncu', title: 'Üçüncü tərəf linkləri' },
  { id: 'xidmet', title: 'Xidmətin dəyişdirilməsi' },
  { id: 'mubahise', title: 'Mübahisələrin həlli' },
  { id: 'qanun', title: 'Tətbiq olunan qanunvericilik' },
  { id: 'deyisiklik', title: 'Dəyişikliklər' },
  { id: 'elaqe', title: 'Əlaqə məlumatları' }
];

export const TermsPage = () => {
  return (
    <div className="bg-white">
      <SEO
        title="İstifadə şərtləri | İDK BOKT"
        description="İDK BOKT saytının istifadə şərtləri — istifadəçi öhdəlikləri, məxfilik və mübahisələrin həlli qaydaları."
        path="/istifade-shertleri"
      />
      {/* Hero */}
      <section className="bg-gradient-to-b from-blue-50 to-white pt-12 pb-8">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <span className="inline-block text-xs font-semibold text-blue-700 uppercase tracking-[0.2em] mb-3">
            Hüquqi sənəd
          </span>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 font-serif-display">İstifadə şərtləri</h1>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Sonuncu yenilənmə tarixi: 1 fevral 2026
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="pt-8 pb-24">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
            {/* Sticky table of contents */}
            <aside className="lg:col-span-4">
              <div className="lg:sticky lg:top-28">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4">
                  Bu səhifədə
                </p>
                <nav className="space-y-1">
                  {sections.map((s, idx) => (
                    <a
                      key={s.id}
                      href={`#${s.id}`}
                      className="block text-sm text-gray-600 hover:text-blue-700 py-1.5 transition-colors"
                    >
                      <span className="font-mono text-xs text-gray-400 mr-2">
                        {String(idx + 1).padStart(2, '0')}
                      </span>
                      {s.title}
                    </a>
                  ))}
                </nav>
              </div>
            </aside>

            {/* Main content */}
            <div className="lg:col-span-8 space-y-12 text-gray-700">
              <Section id="umumi" title="1. Ümumi müddəalar">
                <p>
                  Bu İstifadə şərtləri (bundan sonra — &quot;Şərtlər&quot;) &quot;İnkişafa Dəstək Kreditləri&quot; Bank Olmayan Kredit Təşkilatı
                  Məhdud Məsuliyyətli Cəmiyyətinin (bundan sonra — &quot;İnkişafa Dəstək Kreditləri BOKT&quot;, &quot;biz&quot;) saytının istifadəsi qaydalarını
                  müəyyən edir.
                </p>
                <p>
                  Bu Şərtlər Azərbaycan Respublikasının &quot;Bank olmayan kredit təşkilatları haqqında&quot; Qanununa,
                  &quot;İstehlakçı kreditləri haqqında&quot; Qanununa, Mülki Məcəlləyə və digər müvafiq qanunvericilik aktlarına
                  uyğun olaraq tərtib edilmişdir.
                </p>
              </Section>

              <Section id="qebul" title="2. Şərtlərin qəbulu">
                <p>
                  Saytımıza daxil olmaq və ondan istifadə etməklə siz bu Şərtləri tam və qeyd-şərtsiz qəbul etmiş olursunuz.
                  Şərtlərlə razı olmadığınız halda saytdan istifadə etməməyinizi xahiş edirik.
                </p>
                <p>
                  Müraciət formalarını yalnız 18 yaşına çatmış şəxslər doldura bilər. Formanı göndərməklə siz
                  18 yaşınızın tamam olduğunu təsdiq etmiş sayılırsınız.
                </p>
              </Section>

              <Section id="istifade" title="3. Saytın istifadəsi">
                <p>
                  Sayt yalnız qanuni məqsədlərlə və bu Şərtlərə uyğun istifadə oluna bilər. Siz aşağıdakılara öhdəlik daşıyırsınız:
                </p>
                <ul>
                  <li>Daxil etdiyiniz məlumatların doğru, dəqiq və aktual olmasına;</li>
                  <li>Saytın işinə mane olmamağa və təhlükəsizliyini pozmamağa;</li>
                  <li>Avtomatlaşdırılmış vasitələrlə (bot, parser və s.) məlumat toplamamağa;</li>
                  <li>Saytın hər hansı hissəsini icazəsiz kopyalamamağa və ya təkrar dərc etməməyə.</li>
                </ul>
              </Section>

              <Section id="muraciet" title="4. Müraciət formaları">
                <p>
                  Saytda kredit müraciəti formasının doldurulması rəsmi kredit müqaviləsinin bağlanması demək deyil. Müraciət
                  yalnız ilkin sorğu xarakteri daşıyır və İnkişafa Dəstək Kreditləri BOKT tərəfindən qiymətləndirilməyə tabedir.
                </p>
                <p>
                  Forma doldurularkən siz aşağıdakıları təsdiq edirsiniz:
                </p>
                <ul>
                  <li>Verdiyiniz məlumatlar həqiqətə uyğundur;</li>
                  <li>Şəxsi məlumatlarınızın emalına razılıq vermisiniz;</li>
                  <li>İnkişafa Dəstək Kreditləri BOKT-nin müraciəti rədd etmə hüququna malik olduğunu qəbul edirsiniz.</li>
                </ul>
                <p>
                  Kredit tarixçəsinin yoxlanılması və digər zəruri razılıqlar müraciətin ofisdə rəsmiləşdirilməsi
                  mərhələsində, ayrıca imzalanan sənədlərlə həyata keçirilir.
                </p>
              </Section>

              <Section id="muelliflik" title="5. Müəlliflik hüquqları">
                <p>
                  Saytda yerləşdirilən bütün materiallar — mətnlər, qrafiklər, loqolar, ikonlar, şəkillər, audio və video
                  fayllar, eləcə də saytın strukturu və dizaynı (üçüncü tərəflərə məxsus və ya ictimai domendə olan
                  materiallar, o cümlədən açıq mənbə komponentləri və qanunvericilik aktlarından sitatlar istisna olmaqla) —
                  İnkişafa Dəstək Kreditləri BOKT-nin əqli mülkiyyətidir və Azərbaycan Respublikasının müəlliflik hüququ qanunvericiliyi ilə qorunur.
                </p>
                <p>
                  Yazılı icazə olmadan saytın hər hansı materialının kommersiya məqsədilə istifadəsi qadağandır.
                </p>
              </Section>

              <Section id="qadagan" title="6. Qadağan olunan fəaliyyətlər">
                <p>Saytdan istifadə zamanı aşağıdakılar qəti qadağandır:</p>
                <ul>
                  <li>Yalan və ya yanıltıcı məlumat təqdim etmək;</li>
                  <li>Başqa şəxsin adından müraciət etmək;</li>
                  <li>Saytın təhlükəsizlik sistemlərinə müdaxilə etmək və ya zərərverici proqramlar yerləşdirmək;</li>
                  <li>Avtomatlaşdırılmış skriptlər vasitəsilə kütləvi müraciətlər göndərmək;</li>
                  <li>Digər istifadəçilərin hüquqlarını və ya İnkişafa Dəstək Kreditləri BOKT-nin işgüzar reputasiyasını zədələyəcək hərəkətlər etmək.</li>
                </ul>
              </Section>

              <Section id="mesuliyyet" title="7. Məsuliyyət məhdudiyyətləri">
                <p>
                  İnkişafa Dəstək Kreditləri BOKT saytda yerləşdirilmiş məlumatların dəqiqliyini təmin etməyə çalışır, lakin onların tam, doğru və ya
                  hər zaman aktual olduğuna zəmanət vermir. Kalkulyatordan əldə edilən hesablamalar yalnız ilkin təxmini
                  xarakter daşıyır və rəsmi təklif sayılmır.
                </p>
                <p>
                  İnkişafa Dəstək Kreditləri BOKT aşağıdakı hallarda heç bir məsuliyyət daşımır:
                </p>
                <ul>
                  <li>Saytın müvəqqəti əlçatmaz olması və ya texniki nasazlıqlar nəticəsində yaranan zərərlər;</li>
                  <li>İstifadəçi tərəfindən saytdakı məlumatlardan yanlış istifadə;</li>
                  <li>Üçüncü tərəf saytlarına keçidlər və orada yerləşdirilmiş məlumatların məzmunu.</li>
                </ul>
              </Section>

              <Section id="ucuncu" title="8. Üçüncü tərəf linkləri">
                <p>
                  Saytımızda üçüncü tərəf saytlarına keçid linkləri ola bilər. Bu saytların məzmununa, məxfilik siyasətinə və
                  ya istifadə şərtlərinə görə İnkişafa Dəstək Kreditləri BOKT məsuliyyət daşımır.
                </p>
              </Section>

              <Section id="xidmet" title="9. Xidmətin dəyişdirilməsi">
                <p>
                  İnkişafa Dəstək Kreditləri BOKT istənilən vaxt, əvvəlcədən xəbərdarlıq etmədən saytın hər hansı hissəsini, funksionallığını və ya
                  təklif olunan məhsulları dəyişdirmək, məhdudlaşdırmaq və ya dayandırmaq hüququna malikdir.
                </p>
              </Section>

              <Section id="mubahise" title="10. Mübahisələrin həlli">
                <p>
                  Bu Şərtlərlə bağlı yaranan mübahisələr ilk növbədə danışıqlar yolu ilə həll edilməyə çalışılır. Razılığa
                  gəlinə bilməyən hallarda mübahisə Azərbaycan Respublikasının qanunvericiliyinə uyğun olaraq Bakı şəhəri
                  məhkəmələrində baxılır.
                </p>
              </Section>

              <Section id="qanun" title="11. Tətbiq olunan qanunvericilik">
                <p>
                  Bu İstifadə şərtləri Azərbaycan Respublikasının qanunvericiliyi ilə tənzimlənir və ona uyğun olaraq şərh
                  olunur.
                </p>
              </Section>

              <Section id="deyisiklik" title="12. Dəyişikliklər">
                <p>
                  İnkişafa Dəstək Kreditləri BOKT bu Şərtləri istənilən vaxt yeniləmək hüququna malikdir. Yenilənmiş versiya bu səhifədə dərc olunduğu
                  andan etibarən qüvvəyə minir və səhifənin başındakı &quot;sonuncu yenilənmə tarixi&quot; müvafiq
                  olaraq yenilənir. Saytdan istifadəni davam etdirməklə siz yenilənmiş Şərtləri qəbul etmiş
                  sayılırsınız.
                </p>
              </Section>

              <Section id="elaqe" title="13. Əlaqə məlumatları">
                <p>İstifadə şərtləri ilə bağlı suallarınız üçün bizimlə əlaqə saxlayın:</p>
                <ul>
                  <li><strong>Elektron ünvan:</strong> info@idkcredit.com</li>
                </ul>
              </Section>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const Section = ({ id, title, children }) => (
  <div id={id} className="scroll-mt-28">
    <h2 className="text-2xl font-bold text-gray-900 mb-5 pb-3 border-b border-gray-200">
      {title}
    </h2>
    <div className="space-y-4 text-[15px] leading-relaxed [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-2 [&_li]:leading-relaxed [&_strong]:text-gray-900 [&_strong]:font-semibold">
      {children}
    </div>
  </div>
);
